import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import WebIM from './utils/WebIM';
import '@/assets/font.css'
import {
  Toast,
  Loading,
  Dialog,
  Picker,
  Popup,
  Cascader,
  DatetimePicker,
  Swipe,
  SwipeItem,
  List,
  Form,
  Field,
  Uploader
} from 'vant';
Vue.prototype.$globalGetItem = function (name) {
  let data = null;
  if (localStorage.getItem(name)) {
    if (isValidJSON(localStorage.getItem(name))) {
      data = JSON.parse(localStorage.getItem(name))
    } else {
      data = localStorage.getItem(name)
    }
  }
  return data
}

function isValidJSON(text) {
  try {
    JSON.parse(text);
    return true;
  } catch (error) {
    return false;
  }
}
Vue.use(Toast);
Vue.use(Loading);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Dialog);
Vue.use(Picker);
Vue.use(Popup);
Vue.use(Cascader);
Vue.use(DatetimePicker);
Vue.use(List);
Vue.use(Form);
Vue.use(Field);
Vue.use(Uploader);
// Vue.prototype.$chatAIMsg = ''
// Vue.prototype.$thinking = ''
var vm = new Vue({
  router,
  store,
  WebIM,
  render: h => h(App)
}).$mount('#app')